export const zhCNAgentGuiSlashPalette = {
  slashCommandPalette: "斜杠菜单",
  skillPickerPalette: "技能",
  slashPaletteCommandsGroup: "命令",
  slashPaletteCapabilitiesGroup: "能力",
  slashPaletteCapabilitiesLoading: "能力加载中…",
  slashPaletteSkillsGroup: "技能",
  slashPalettePluginsGroup: "插件",
  slashPaletteConnectorsGroup: "连接器",
  slashPaletteConnectorConnected: "已授权",
  slashPaletteConnectorNotConnected: "安装",
  slashPaletteConnectorUnsupported: "不支持",
  slashPaletteMcpGroup: "MCP"
} as const;
